namespace Areas.Dialogs {
    "use strict";

    export class CreateWarrantyProfileDialog extends Areas.BaseDialog {

        constructor(closeHandler: (dialogResult: DialogResult, data: any) => void) {
            super("CreateWarrantyProfile", closeHandler);
        }

        protected ok = (e: any) => {
            const form = $("#CreateWarrantyProfileForm").dxForm("instance");
            const result: any = form.validate();

            if (result.isValid) {

                const newData: any = form.option("formData");
                newData.ProfileStatusLk = "Active";
                newData.ProfileTypeLk = "All";
                sendRequest("/Dialog/CreateWarrantyProfile/Post", JSON.stringify(newData), "POST");
            }
        }
    }


}